import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from '@chakra-ui/react';
import { useEffect, useState, useCallback } from 'react';
import ModalHeaderComponent from '../../../../components/ModalHeader';
import { requestServerApi, serverApi } from '../../../../api/api';
import { lessonByLearnerId } from '../../../../interfaces/learnerInterface';
import useErrorPage from '../../../../hooks/useErrorPage/useErrorPage';
import { useHistory } from 'react-router-dom';
import { getFormattedDatetime, getFormattedTime } from '../../../../components/Format';
import {
  getLessonLearnerStatusBadge,
  getLessonStatusBadge,
} from '../../../../components/BadgeStatus';
import CustomPagination from '../../../../components/CustomPagination';

export default function LessonsModal({ onClose, modalData }: any) {
  const [futureLessons, setFutureLessons] = useState<lessonByLearnerId[]>([]);
  const [totalFutureLessonsCount, setTotalFutureLessonsCount] = useState<number>(0);
  const [totalFutureLessonPage, setTotalFutureLessonsPage] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const limit: number = 7;
  const [listViewErrorMsg, setListViewErrorMsg] = useState<string>('');
  const [lessonLearnersList, setLessonLearnersList] = useState<any>([]);
  const [refreshFlg, setRefreshFlg] = useState(false);

  const closeModal = () => {
    onClose('lessonsModal', '');
  };

  const { company_id, learner_id } = modalData || {};

  const { apiErrorHandler } = useErrorPage();
  const history = useHistory();
  const isRefreshed = refreshFlg === true;

  // 学習者のレッスン予定一覧を取得
  const getFutureLessonByLearnerId = useCallback(() => {
    const response = requestServerApi<any>(() =>
      serverApi
        .organizationsControllerGetFutureLessonList(
          company_id,
          -1,
          '',
          learner_id,
          '',
          0,
          '',
          '',
          0,
          limit,
          currentPage,
        )
        .catch((e: any) =>
          apiErrorHandler(e, {
            componentName: 'learner',
            functionName: serverApi.organizationsControllerGetFutureLessonList.name,
          }),
        ),
    );
    response.then((result) => {
      const apiResponse = result.data;
      if (apiResponse.data) {
        let lessonList = apiResponse.data[0];
        if (apiResponse?.data[1] == 0 || apiResponse?.data[1] == undefined) {
          setListViewErrorMsg('データはありません');
        } else {
          for (const lesson in lessonList) {
            let learners: string[] = [];
            let count = 1;
            let learners_array: any = [];

            //get lesson details
            const learnerResponse = requestServerApi<any>(() =>
              serverApi
                .organizationsControllerGetLesson(
                  lessonList[lesson]?.company_id,
                  '',
                  lessonList[lesson]?.lesson_id,
                  '',
                  '',
                  '',
                  '',
                )
                .catch((e: any) =>
                  apiErrorHandler(e, {
                    componentName: 'learner',
                    functionName: serverApi.organizationsControllerGetLesson.name,
                  }),
                ),
            );
            learnerResponse.then((result) => {
              const learnerApiResponse = result.data;
              //store the api response
              learners_array = learnerApiResponse?.data[0]?.t_lesson_learner;
              //store learner names
              if (learners_array?.length > 0) {
                for (const learner in learners_array) {
                  //set lesson learners
                  if (count <= limit) {
                    learners.push(learners_array[learner]?.m_learner?.nick_name);
                    count += 1;
                  }
                  if (count > 3) {
                    learners[3] = ' 他';
                    break;
                  }
                }
                learners = learners.toString() as any;
                //set lesson learners in a list
                setLessonLearnersList((learnerList: any) => [...learnerList, learners]);
              }
            });
          }
          setFutureLessons(apiResponse.data[0]);
          setTotalFutureLessonsPage(
            apiResponse.data[1] >= limit ? Math.ceil(apiResponse?.data[1] / limit) : 1,
          );
          setTotalFutureLessonsCount(apiResponse.data[1]);
          setListViewErrorMsg('');
        }
      }
    });
  }, [company_id, learner_id, currentPage, limit, apiErrorHandler]);

  useEffect(() => {
    getFutureLessonByLearnerId();
  }, [currentPage, isRefreshed, getFutureLessonByLearnerId]);

  useEffect(() => {
    setLessonLearnersList([]);
    setRefreshFlg(false);
  }, [currentPage, isRefreshed]);

  // レッスン詳細遷移
  const onClickLessonDetail = (lesson_id: number, company_id: number) => {
    history.push(`/lesson/${company_id}/${lesson_id}`, {
      company_id: company_id,
      lesson_id: lesson_id,
    });
  };

  const handlePageChange = (targetPage: number) => {
    setCurrentPage(targetPage);
  };

  return (
    <Modal isOpen={true} onClose={closeModal} size="6xl">
      <ModalOverlay />
      <ModalContent maxHeight="80vh">
        <ModalHeaderComponent title={'レッスン一覧'} />
        <ModalBody overflowY="auto">
          <Box className="learner-DataCountArea">
            <Box>{`総件数: ${totalFutureLessonsCount}件`}</Box>
          </Box>
          <Box>
            {listViewErrorMsg !== '' ? (
              <Box backgroundColor="yellow" textAlign="center">
                {listViewErrorMsg}
              </Box>
            ) : (
              <Box className="Learner-Table">
                <Table variant="simple">
                  <Thead className="Learner-TableHead">
                    <Tr>
                      <Th />
                      <Th>ステータス</Th>
                      <Th>レッスン日時</Th>
                      <Th>教師</Th>
                      <Th>学習者</Th>
                      <Th>契約名</Th>
                    </Tr>
                  </Thead>
                  <Tbody className="Learner-TableBody" cursor={'pointer'}>
                    {futureLessons.map((lesson: any, idx: number) => (
                      <Tr
                        key={idx}
                        onClick={() => onClickLessonDetail(lesson.lesson_id, lesson.company_id)}
                      >
                        <Td>
                          <Button
                            colorScheme="linkedin"
                            size="sm"
                            onClick={() => onClickLessonDetail(lesson.lesson_id, lesson.company_id)}
                          >
                            レッスン詳細
                          </Button>
                        </Td>
                        <Td>
                          {getLessonStatusBadge(lesson)}
                          {getLessonLearnerStatusBadge(lesson)}
                        </Td>
                        <Td>
                          {getFormattedDatetime(lesson?.start_datetime, true)}
                          {' ~ '}
                          {getFormattedTime(lesson?.end_datetime)}
                        </Td>
                        <Td>{lesson.t_lesson_teacher[0].m_teacher.full_name}</Td>
                        <Td width="100%">{lessonLearnersList[idx]}</Td>
                        <Td>{lesson?.t_payment_company?.plan_name}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
                <Box className="Learner-PaginationArea">
                  {futureLessons?.length > 0 && (
                    <CustomPagination
                      page={currentPage}
                      totalPages={totalFutureLessonPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
